module.exports = __webpack_public_path__ + "static/SM4-a75d365e5b7701599d95536b815badd1.png";